import React from 'react';

const History = ({ analyses }) => {
  if (!analyses || analyses.length === 0) {
    return (
      <div className="card" style={{ marginTop: '2rem' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '1rem', color: '#004e92', textAlign: 'center' }}>
          💾 Historial de Análisis
        </h2>
        <p style={{ textAlign: 'center', color: '#94a3b8' }}>
          Aún no hay análisis guardados.
        </p>
      </div>
    );
  }

  const sortedAnalyses = [...analyses].sort((a, b) => 
    (b.timestamp?.seconds || 0) - (a.timestamp?.seconds || 0)
  );

  return (
    <div className="card" style={{ marginTop: '2rem' }}>
      <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '1.5rem', color: '#004e92', textAlign: 'center' }}>
        💾 Historial de Análisis
      </h2>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        {sortedAnalyses.map((analysis, index) => {
          const date = analysis.timestamp 
            ? new Date(analysis.timestamp.seconds * 1000).toLocaleString('es-ES', { 
                dateStyle: 'medium', 
                timeStyle: 'short' 
              })
            : 'Fecha desconocida';
          
          const typeLabel = {
            scenario: 'ANÁLISIS DE ESCENARIO',
            concept: 'DEFINICIÓN DE CONCEPTO',
            stability: 'ANÁLISIS DE ESTABILIDAD',
            section: 'ANÁLISIS DE SECCIÓN'
          }[analysis.type] || 'ANÁLISIS GENERAL';

          return (
            <details key={index} style={{ 
              backgroundColor: '#1e293b', 
              padding: '1rem', 
              borderRadius: '0.5rem',
              border: '1px solid #475569'
            }}>
              <summary style={{ cursor: 'pointer', fontWeight: '600', color: '#e2e8f0' }}>
                <span style={{ 
                  backgroundColor: '#3b82f6', 
                  color: 'white', 
                  padding: '0.25rem 0.5rem', 
                  borderRadius: '0.25rem',
                  fontSize: '0.75rem',
                  marginRight: '0.5rem'
                }}>
                  {typeLabel}
                </span>
                {analysis.query.substring(0, 50)}...
                <span style={{ float: 'right', fontSize: '0.75rem', color: '#94a3b8' }}>
                  {date}
                </span>
              </summary>
              <div style={{ 
                marginTop: '1rem', 
                padding: '1rem', 
                backgroundColor: 'rgba(51, 65, 85, 0.3)',
                borderRadius: '0.5rem',
                borderLeft: '3px solid #3b82f6',
                lineHeight: '1.7',
                color: '#e2e8f0'
              }}>
                {analysis.result.split('\n').map((line, i) => (
                  <p key={i} style={{ marginBottom: '0.5rem' }}>{line}</p>
                ))}
              </div>
            </details>
          );
        })}
      </div>
    </div>
  );
};

export default History;
